var _style, _path, _circle, _circle2, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReproductiveHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reproductive-health_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".reproductive-health_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "reproductive-health_svg__st0",
    d: "M38.4 82.9v28.4M52.1 97.6H24.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "reproductive-health_svg__st0",
    cx: 38.4,
    cy: 58.5,
    r: 24.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "reproductive-health_svg__st0",
    cx: 96.4,
    cy: 89.5,
    r: 24.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "reproductive-health_svg__st0",
    d: "M113.7 72.3l20-20.1-17.1-.2M133.7 52.2l.2 17.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8 44.8c-3.6-3.5-8.3-5.4-13.4-5.4s-9.9 2-13.5 5.6c-7.5 7.5-7.5 19.6 0 27 .6.6 1.3 1.2 2 1.7-3.1-12.8-2.8-31.2 24.9-28.9z",
    fill: "var(--color-icon-secondary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9 99.1c.8 1.4 1.8 2.7 3 3.9 3.6 3.6 8.4 5.6 13.5 5.6s9.9-2 13.5-5.6c4.4-4.4 6.2-10.5 5.4-16.3-9.6 17.5-24.5 16.4-35.4 12.4z",
    fill: "var(--color-icon-primary)"
  })));
}
export default SvgReproductiveHealth;